import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import NetworkImageWithLink from "../../../components/image/NetworkImageWithLink";
import { SwiperArrows } from "./SwiperArrows";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

export const WideBanner: React.FC<{
  banners: BannerDTO[];
  children?: React.ReactNode;
}> = ({ children, banners }) => {
  return (
    <div className="relative flex h-[22.875rem] flex-col items-center justify-center space-y-4 !bg-white bg-cover bg-center">
      <div className="absolute inset-0 h-full w-full">
        {!!banners.length && (
          <>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              // spaceBetween={8}
              slidesPerView={1}
              pagination={true}
              // autoplay={{ delay: 4000 }}
              loop={true}
              navigation={{
                nextEl: "#wide-banner-next",
                prevEl: "#wide-banner-prev",
              }}
            >
              {banners.map((m, i) => (
                <SwiperSlide key={m.id}>
                  <NetworkImageWithLink
                    {...m}
                    loading={i === 0 ? "eager" : "lazy"}
                    className={"!h-[22.875rem] !rounded-none"}
                    fetchPriority={i === 0 ? "high" : "low"}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <SwiperArrows prefix="wide" />
          </>
        )}
      </div>

      <div className="absolute inset-0 bg-black bg-opacity-20"></div>
      {children}
    </div>
  );
};
